module.exports = __webpack_public_path__ + "static/img/sprite_adolescent_1_autumn.2ab64ee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/adolescents/sprite_adolescent_1_autumn.svg
// module id = wM0n
// module chunks = 1